/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Right_Rail_DescriptionInputs */

const en_directory_promotion_placements_right_rail_description = /** @type {(inputs: Directory_Promotion_Placements_Right_Rail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserve a secondary directory placement for an active campaign.`)
};

const zh_directory_promotion_placements_right_rail_description = /** @type {(inputs: Directory_Promotion_Placements_Right_Rail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为进行中的推广活动预留次级目录位置。`)
};

/**
* | output |
* | --- |
* | "Reserve a secondary directory placement for an active campaign." |
*
* @param {Directory_Promotion_Placements_Right_Rail_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_right_rail_description = /** @type {((inputs?: Directory_Promotion_Placements_Right_Rail_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Right_Rail_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_right_rail_description(inputs)
	return zh_directory_promotion_placements_right_rail_description(inputs)
});
export { directory_promotion_placements_right_rail_description as "directory.promotion.placements.right-rail.description" }